(function($) {
    $(document).foundation();
})(jQuery);